export class EFormDatabaseField {
    ID: number;
    FieldName: string;
    ColumnName: string;
    FieldType: string;
    IsDataDef: boolean;
    DataDefType: number;
    DataFieldGroup_ID: number;
    DataFieldGroupName: string;
    DataValueField: string;
    ControlType: string;
    Value: string;
   }